import Graficas from './Graficas';
export default Graficas;